<template>
  <div class="index_wrap" >
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.accountHolder"
        name="accountHolder"
        label="开户人姓名"
        placeholder="开户人姓名"
        :rules="[{ required: true, message: '请输入开户人姓名' }]"
      />
      <van-field
        v-model="form.bankCardNumber"
        name="bankCardNumber"
        label="银行卡号"
        placeholder="请输入银行卡号"
        :rules="[{ required: true, message: '请输入银行卡号' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" class="submit_button" :loading="submitting" >提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  getVo,
  updateBankCard
} from '@/api/bank'
import {
  Toast
} from 'vant'
export default {
  name: 'bank',
  data() {
    return {
      form: {
        accountHolder: '',
        bankCardNumber: ''
      },
      submitting: false,
    }
  },
  methods: {
    onSubmit(values) {
      this.submitting = true
      updateBankCard({...values}).then(res => {
        this.submitting = false
        if(res.success) {
          Toast('设置成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    },
    getVo() {
      getVo({}).then(res => {
        if(res.success) {
          this.form = {
            ...res.data
          }
        }
      })
    }
  },
  mounted(){
    this.getVo()
  }
}
</script>
